import { motion } from 'framer-motion';
import { useState } from 'react';
import SplitTextTest from './SplitTextTest';

const Hero = ({ siteData }) => {
  const [showCursor, setShowCursor] = useState(false);
  
  const handleAnimationComplete = () => {
    console.log('All letters have animated!');
    setShowCursor(true);
    console.log('showCursor set to true');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center" style={{ backgroundColor: 'oklch(0.23 0.002 264)' }}>
      <div className="container-custom relative z-10">
        <div className="flex flex-col items-center text-center space-y-12 pt-16">
          {/* Tech Circle with Continuous Animation */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ 
              opacity: 1, 
              scale: 1,
              transition: {
                duration: 0.8,
                ease: [0.16, 1, 0.3, 1]
              }
            }}
            className="relative mb-4"
          >
            <motion.div
              animate={{ 
                rotate: 360,
              }}
              transition={{ 
                duration: 20,
                repeat: Infinity,
                ease: "linear"
              }}
              className="w-64 h-64"
            >
              <svg
                viewBox="0 0 100 100"
                className="w-full h-full"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* Neural Network Mesh */}
                {/* Outer Network Nodes */}
                <motion.circle cx="20" cy="20" r="2" fill="#3b82f6" opacity="0.8" />
                <motion.circle cx="80" cy="20" r="2" fill="#10b981" opacity="0.8" />
                <motion.circle cx="20" cy="80" r="2" fill="#f59e0b" opacity="0.8" />
                <motion.circle cx="80" cy="80" r="2" fill="#ef4444" opacity="0.8" />
                <motion.circle cx="10" cy="50" r="1.5" fill="#8b5cf6" opacity="0.6" />
                <motion.circle cx="90" cy="50" r="1.5" fill="#06b6d4" opacity="0.6" />
                <motion.circle cx="50" cy="10" r="1.5" fill="#a855f7" opacity="0.6" />
                <motion.circle cx="50" cy="90" r="1.5" fill="#22c55e" opacity="0.6" />
                
                {/* Middle Network Nodes */}
                <motion.circle cx="35" cy="35" r="1.5" fill="#3b82f6" opacity="0.7" />
                <motion.circle cx="65" cy="35" r="1.5" fill="#10b981" opacity="0.7" />
                <motion.circle cx="35" cy="65" r="1.5" fill="#f59e0b" opacity="0.7" />
                <motion.circle cx="65" cy="65" r="1.5" fill="#ef4444" opacity="0.7" />
                
                {/* Neural Network Connections */}
                <motion.line
                  x1="20" y1="20" x2="80" y2="20"
                  stroke="#3b82f6" strokeWidth="0.5" opacity="0.4"
                  animate={{ opacity: [0.2, 0.8, 0.2] }}
                  transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                />
                <motion.line
                  x1="20" y1="80" x2="80" y2="80"
                  stroke="#10b981" strokeWidth="0.5" opacity="0.4"
                  animate={{ opacity: [0.2, 0.8, 0.2] }}
                  transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                />
                <motion.line
                  x1="20" y1="20" x2="20" y2="80"
                  stroke="#f59e0b" strokeWidth="0.5" opacity="0.4"
                  animate={{ opacity: [0.2, 0.8, 0.2] }}
                  transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut", delay: 1 }}
                />
                <motion.line
                  x1="80" y1="20" x2="80" y2="80"
                  stroke="#ef4444" strokeWidth="0.5" opacity="0.4"
                  animate={{ opacity: [0.2, 0.8, 0.2] }}
                  transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                />
                
                {/* Diagonal Connections */}
                <motion.line
                  x1="20" y1="20" x2="80" y2="80"
                  stroke="#8b5cf6" strokeWidth="0.3" opacity="0.3"
                  animate={{ opacity: [0.1, 0.6, 0.1] }}
                  transition={{ duration: 3, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
                />
                <motion.line
                  x1="80" y1="20" x2="20" y2="80"
                  stroke="#06b6d4" strokeWidth="0.3" opacity="0.3"
                  animate={{ opacity: [0.1, 0.6, 0.1] }}
                  transition={{ duration: 2.8, repeat: Infinity, ease: "easeInOut", delay: 1.2 }}
                />
                
                {/* Cross Connections */}
                <motion.line
                  x1="10" y1="50" x2="90" y2="50"
                  stroke="#a855f7" strokeWidth="0.4" opacity="0.3"
                  animate={{ opacity: [0.1, 0.5, 0.1] }}
                  transition={{ duration: 2.3, repeat: Infinity, ease: "easeInOut", delay: 0.7 }}
                />
                <motion.line
                  x1="50" y1="10" x2="50" y2="90"
                  stroke="#22c55e" strokeWidth="0.4" opacity="0.3"
                  animate={{ opacity: [0.1, 0.5, 0.1] }}
                  transition={{ duration: 2.7, repeat: Infinity, ease: "easeInOut", delay: 1.5 }}
                />
                
                {/* Inner Network Connections */}
                <motion.line
                  x1="35" y1="35" x2="65" y2="35"
                  stroke="#3b82f6" strokeWidth="0.3" opacity="0.4"
                  animate={{ opacity: [0.2, 0.7, 0.2] }}
                  transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
                />
                <motion.line
                  x1="35" y1="65" x2="65" y2="65"
                  stroke="#10b981" strokeWidth="0.3" opacity="0.4"
                  animate={{ opacity: [0.2, 0.7, 0.2] }}
                  transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut", delay: 0.9 }}
                />
                <motion.line
                  x1="35" y1="35" x2="35" y2="65"
                  stroke="#f59e0b" strokeWidth="0.3" opacity="0.4"
                  animate={{ opacity: [0.2, 0.7, 0.2] }}
                  transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                />
                <motion.line
                  x1="65" y1="35" x2="65" y2="65"
                  stroke="#ef4444" strokeWidth="0.3" opacity="0.4"
                  animate={{ opacity: [0.2, 0.7, 0.2] }}
                  transition={{ duration: 1.7, repeat: Infinity, ease: "easeInOut", delay: 1.1 }}
                />
                
                {/* Additional Mesh Lines - Outer to Inner */}
                <motion.line
                  x1="20" y1="20" x2="35" y2="35"
                  stroke="#3b82f6" strokeWidth="0.2" opacity="0.3"
                  animate={{ opacity: [0.1, 0.5, 0.1] }}
                  transition={{ duration: 2.1, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
                />
                <motion.line
                  x1="80" y1="20" x2="65" y2="35"
                  stroke="#10b981" strokeWidth="0.2" opacity="0.3"
                  animate={{ opacity: [0.1, 0.5, 0.1] }}
                  transition={{ duration: 2.3, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                />
                <motion.line
                  x1="20" y1="80" x2="35" y2="65"
                  stroke="#f59e0b" strokeWidth="0.2" opacity="0.3"
                  animate={{ opacity: [0.1, 0.5, 0.1] }}
                  transition={{ duration: 1.9, repeat: Infinity, ease: "easeInOut", delay: 1.3 }}
                />
                <motion.line
                  x1="80" y1="80" x2="65" y2="65"
                  stroke="#ef4444" strokeWidth="0.2" opacity="0.3"
                  animate={{ opacity: [0.1, 0.5, 0.1] }}
                  transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                />
                
                {/* Cross-connections to center nodes */}
                <motion.line
                  x1="10" y1="50" x2="35" y2="35"
                  stroke="#8b5cf6" strokeWidth="0.2" opacity="0.25"
                  animate={{ opacity: [0.05, 0.4, 0.05] }}
                  transition={{ duration: 2.6, repeat: Infinity, ease: "easeInOut", delay: 1.0 }}
                />
                <motion.line
                  x1="90" y1="50" x2="65" y2="35"
                  stroke="#06b6d4" strokeWidth="0.2" opacity="0.25"
                  animate={{ opacity: [0.05, 0.4, 0.05] }}
                  transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                />
                <motion.line
                  x1="50" y1="10" x2="35" y2="35"
                  stroke="#a855f7" strokeWidth="0.2" opacity="0.25"
                  animate={{ opacity: [0.05, 0.4, 0.05] }}
                  transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut", delay: 1.4 }}
                />
                <motion.line
                  x1="50" y1="90" x2="35" y2="65"
                  stroke="#22c55e" strokeWidth="0.2" opacity="0.25"
                  animate={{ opacity: [0.05, 0.4, 0.05] }}
                  transition={{ duration: 2.7, repeat: Infinity, ease: "easeInOut", delay: 0.9 }}
                />
                
                {/* Additional diagonal connections */}
                <motion.line
                  x1="20" y1="20" x2="50" y2="50"
                  stroke="#3b82f6" strokeWidth="0.15" opacity="0.2"
                  animate={{ opacity: [0.05, 0.3, 0.05] }}
                  transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut", delay: 0.7 }}
                />
                <motion.line
                  x1="80" y1="20" x2="50" y2="50"
                  stroke="#10b981" strokeWidth="0.15" opacity="0.2"
                  animate={{ opacity: [0.05, 0.3, 0.05] }}
                  transition={{ duration: 2.9, repeat: Infinity, ease: "easeInOut", delay: 1.1 }}
                />
                <motion.line
                  x1="20" y1="80" x2="50" y2="50"
                  stroke="#f59e0b" strokeWidth="0.15" opacity="0.2"
                  animate={{ opacity: [0.05, 0.3, 0.05] }}
                  transition={{ duration: 3.1, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
                />
                <motion.line
                  x1="80" y1="80" x2="50" y2="50"
                  stroke="#ef4444" strokeWidth="0.15" opacity="0.2"
                  animate={{ opacity: [0.05, 0.3, 0.05] }}
                  transition={{ duration: 2.8, repeat: Infinity, ease: "easeInOut", delay: 1.6 }}
                />
                
                {/* Inner to center connections */}
                <motion.line
                  x1="35" y1="35" x2="50" y2="50"
                  stroke="#8b5cf6" strokeWidth="0.2" opacity="0.3"
                  animate={{ opacity: [0.1, 0.4, 0.1] }}
                  transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
                />
                <motion.line
                  x1="65" y1="35" x2="50" y2="50"
                  stroke="#06b6d4" strokeWidth="0.2" opacity="0.3"
                  animate={{ opacity: [0.1, 0.4, 0.1] }}
                  transition={{ duration: 2.0, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                />
                <motion.line
                  x1="35" y1="65" x2="50" y2="50"
                  stroke="#a855f7" strokeWidth="0.2" opacity="0.3"
                  animate={{ opacity: [0.1, 0.4, 0.1] }}
                  transition={{ duration: 1.9, repeat: Infinity, ease: "easeInOut", delay: 1.2 }}
                />
                <motion.line
                  x1="65" y1="65" x2="50" y2="50"
                  stroke="#22c55e" strokeWidth="0.2" opacity="0.3"
                  animate={{ opacity: [0.1, 0.4, 0.1] }}
                  transition={{ duration: 2.1, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                />
                
                {/* Ultra-dense mesh lines - Cross connections */}
                <motion.line
                  x1="20" y1="20" x2="35" y2="65"
                  stroke="#3b82f6" strokeWidth="0.1" opacity="0.15"
                  animate={{ opacity: [0.02, 0.25, 0.02] }}
                  transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut", delay: 0.1 }}
                />
                <motion.line
                  x1="80" y1="20" x2="65" y2="65"
                  stroke="#10b981" strokeWidth="0.1" opacity="0.15"
                  animate={{ opacity: [0.02, 0.25, 0.02] }}
                  transition={{ duration: 3.3, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                />
                <motion.line
                  x1="20" y1="80" x2="35" y2="35"
                  stroke="#f59e0b" strokeWidth="0.1" opacity="0.15"
                  animate={{ opacity: [0.02, 0.25, 0.02] }}
                  transition={{ duration: 3.7, repeat: Infinity, ease: "easeInOut", delay: 1.1 }}
                />
                <motion.line
                  x1="80" y1="80" x2="65" y2="35"
                  stroke="#ef4444" strokeWidth="0.1" opacity="0.15"
                  animate={{ opacity: [0.02, 0.25, 0.02] }}
                  transition={{ duration: 3.1, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
                />
                
                {/* Additional cross-connections */}
                <motion.line
                  x1="10" y1="50" x2="65" y2="35"
                  stroke="#8b5cf6" strokeWidth="0.1" opacity="0.12"
                  animate={{ opacity: [0.01, 0.2, 0.01] }}
                  transition={{ duration: 4.2, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                />
                <motion.line
                  x1="90" y1="50" x2="35" y2="35"
                  stroke="#06b6d4" strokeWidth="0.1" opacity="0.12"
                  animate={{ opacity: [0.01, 0.2, 0.01] }}
                  transition={{ duration: 3.9, repeat: Infinity, ease: "easeInOut", delay: 1.3 }}
                />
                <motion.line
                  x1="50" y1="10" x2="35" y2="65"
                  stroke="#a855f7" strokeWidth="0.1" opacity="0.12"
                  animate={{ opacity: [0.01, 0.2, 0.01] }}
                  transition={{ duration: 4.1, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
                />
                <motion.line
                  x1="50" y1="90" x2="65" y2="35"
                  stroke="#22c55e" strokeWidth="0.1" opacity="0.12"
                  animate={{ opacity: [0.01, 0.2, 0.01] }}
                  transition={{ duration: 3.8, repeat: Infinity, ease: "easeInOut", delay: 1.7 }}
                />
                
                {/* Micro-connections between outer nodes */}
                <motion.line
                  x1="10" y1="50" x2="20" y2="20"
                  stroke="#3b82f6" strokeWidth="0.08" opacity="0.1"
                  animate={{ opacity: [0.01, 0.15, 0.01] }}
                  transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                />
                <motion.line
                  x1="90" y1="50" x2="80" y2="20"
                  stroke="#10b981" strokeWidth="0.08" opacity="0.1"
                  animate={{ opacity: [0.01, 0.15, 0.01] }}
                  transition={{ duration: 4.3, repeat: Infinity, ease: "easeInOut", delay: 1.2 }}
                />
                <motion.line
                  x1="50" y1="10" x2="20" y2="20"
                  stroke="#f59e0b" strokeWidth="0.08" opacity="0.1"
                  animate={{ opacity: [0.01, 0.15, 0.01] }}
                  transition={{ duration: 4.7, repeat: Infinity, ease: "easeInOut", delay: 0.9 }}
                />
                <motion.line
                  x1="50" y1="90" x2="20" y2="80"
                  stroke="#ef4444" strokeWidth="0.08" opacity="0.1"
                  animate={{ opacity: [0.01, 0.15, 0.01] }}
                  transition={{ duration: 4.4, repeat: Infinity, ease: "easeInOut", delay: 1.5 }}
                />
                
                {/* Additional micro-connections */}
                <motion.line
                  x1="10" y1="50" x2="80" y2="80"
                  stroke="#8b5cf6" strokeWidth="0.08" opacity="0.08"
                  animate={{ opacity: [0.005, 0.12, 0.005] }}
                  transition={{ duration: 5.1, repeat: Infinity, ease: "easeInOut", delay: 0.7 }}
                />
                <motion.line
                  x1="90" y1="50" x2="20" y2="80"
                  stroke="#06b6d4" strokeWidth="0.08" opacity="0.08"
                  animate={{ opacity: [0.005, 0.12, 0.005] }}
                  transition={{ duration: 4.9, repeat: Infinity, ease: "easeInOut", delay: 1.4 }}
                />
                <motion.line
                  x1="50" y1="10" x2="80" y2="80"
                  stroke="#a855f7" strokeWidth="0.08" opacity="0.08"
                  animate={{ opacity: [0.005, 0.12, 0.005] }}
                  transition={{ duration: 5.3, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
                />
                <motion.line
                  x1="50" y1="90" x2="80" y2="20"
                  stroke="#22c55e" strokeWidth="0.08" opacity="0.08"
                  animate={{ opacity: [0.005, 0.12, 0.005] }}
                  transition={{ duration: 4.8, repeat: Infinity, ease: "easeInOut", delay: 1.8 }}
                />
                
                {/* Ultra-micro connections */}
                <motion.line
                  x1="35" y1="35" x2="80" y2="20"
                  stroke="#3b82f6" strokeWidth="0.05" opacity="0.06"
                  animate={{ opacity: [0.003, 0.08, 0.003] }}
                  transition={{ duration: 6.2, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
                />
                <motion.line
                  x1="65" y1="35" x2="20" y2="20"
                  stroke="#10b981" strokeWidth="0.05" opacity="0.06"
                  animate={{ opacity: [0.003, 0.08, 0.003] }}
                  transition={{ duration: 5.8, repeat: Infinity, ease: "easeInOut", delay: 1.1 }}
                />
                <motion.line
                  x1="35" y1="65" x2="80" y2="80"
                  stroke="#f59e0b" strokeWidth="0.05" opacity="0.06"
                  animate={{ opacity: [0.003, 0.08, 0.003] }}
                  transition={{ duration: 6.5, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                />
                <motion.line
                  x1="65" y1="65" x2="20" y2="80"
                  stroke="#ef4444" strokeWidth="0.05" opacity="0.06"
                  animate={{ opacity: [0.003, 0.08, 0.003] }}
                  transition={{ duration: 5.9, repeat: Infinity, ease: "easeInOut", delay: 1.6 }}
                />
                
                {/* Extreme density - Additional micro connections */}
                <motion.line
                  x1="20" y1="20" x2="10" y2="50"
                  stroke="#8b5cf6" strokeWidth="0.04" opacity="0.05"
                  animate={{ opacity: [0.002, 0.06, 0.002] }}
                  transition={{ duration: 7.1, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
                />
                <motion.line
                  x1="80" y1="20" x2="90" y2="50"
                  stroke="#06b6d4" strokeWidth="0.04" opacity="0.05"
                  animate={{ opacity: [0.002, 0.06, 0.002] }}
                  transition={{ duration: 6.8, repeat: Infinity, ease: "easeInOut", delay: 1.0 }}
                />
                <motion.line
                  x1="20" y1="80" x2="10" y2="50"
                  stroke="#a855f7" strokeWidth="0.04" opacity="0.05"
                  animate={{ opacity: [0.002, 0.06, 0.002] }}
                  transition={{ duration: 7.3, repeat: Infinity, ease: "easeInOut", delay: 1.4 }}
                />
                <motion.line
                  x1="80" y1="80" x2="90" y2="50"
                  stroke="#22c55e" strokeWidth="0.04" opacity="0.05"
                  animate={{ opacity: [0.002, 0.06, 0.002] }}
                  transition={{ duration: 6.9, repeat: Infinity, ease: "easeInOut", delay: 0.7 }}
                />
                
                {/* More extreme density - Cross micro connections */}
                <motion.line
                  x1="20" y1="20" x2="50" y2="10"
                  stroke="#3b82f6" strokeWidth="0.04" opacity="0.05"
                  animate={{ opacity: [0.002, 0.06, 0.002] }}
                  transition={{ duration: 7.5, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                />
                <motion.line
                  x1="80" y1="20" x2="50" y2="10"
                  stroke="#10b981" strokeWidth="0.04" opacity="0.05"
                  animate={{ opacity: [0.002, 0.06, 0.002] }}
                  transition={{ duration: 7.2, repeat: Infinity, ease: "easeInOut", delay: 1.3 }}
                />
                <motion.line
                  x1="20" y1="80" x2="50" y2="90"
                  stroke="#f59e0b" strokeWidth="0.04" opacity="0.05"
                  animate={{ opacity: [0.002, 0.06, 0.002] }}
                  transition={{ duration: 7.7, repeat: Infinity, ease: "easeInOut", delay: 0.9 }}
                />
                <motion.line
                  x1="80" y1="80" x2="50" y2="90"
                  stroke="#ef4444" strokeWidth="0.04" opacity="0.05"
                  animate={{ opacity: [0.002, 0.06, 0.002] }}
                  transition={{ duration: 7.4, repeat: Infinity, ease: "easeInOut", delay: 1.7 }}
                />
                
                {/* Ultra-extreme density - Inner cross connections */}
                <motion.line
                  x1="35" y1="35" x2="10" y2="50"
                  stroke="#8b5cf6" strokeWidth="0.03" opacity="0.04"
                  animate={{ opacity: [0.001, 0.04, 0.001] }}
                  transition={{ duration: 8.2, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                />
                <motion.line
                  x1="65" y1="35" x2="90" y2="50"
                  stroke="#06b6d4" strokeWidth="0.03" opacity="0.04"
                  animate={{ opacity: [0.001, 0.04, 0.001] }}
                  transition={{ duration: 8.5, repeat: Infinity, ease: "easeInOut", delay: 1.2 }}
                />
                <motion.line
                  x1="35" y1="65" x2="10" y2="50"
                  stroke="#a855f7" strokeWidth="0.03" opacity="0.04"
                  animate={{ opacity: [0.001, 0.04, 0.001] }}
                  transition={{ duration: 8.8, repeat: Infinity, ease: "easeInOut", delay: 1.8 }}
                />
                <motion.line
                  x1="65" y1="65" x2="90" y2="50"
                  stroke="#22c55e" strokeWidth="0.03" opacity="0.04"
                  animate={{ opacity: [0.001, 0.04, 0.001] }}
                  transition={{ duration: 8.1, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                />
                
                {/* Maximum density - Ultra micro connections */}
                <motion.line
                  x1="35" y1="35" x2="50" y2="10"
                  stroke="#3b82f6" strokeWidth="0.03" opacity="0.04"
                  animate={{ opacity: [0.001, 0.04, 0.001] }}
                  transition={{ duration: 9.1, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
                />
                <motion.line
                  x1="65" y1="35" x2="50" y2="10"
                  stroke="#10b981" strokeWidth="0.03" opacity="0.04"
                  animate={{ opacity: [0.001, 0.04, 0.001] }}
                  transition={{ duration: 9.4, repeat: Infinity, ease: "easeInOut", delay: 1.5 }}
                />
                <motion.line
                  x1="35" y1="65" x2="50" y2="90"
                  stroke="#f59e0b" strokeWidth="0.03" opacity="0.04"
                  animate={{ opacity: [0.001, 0.04, 0.001] }}
                  transition={{ duration: 9.7, repeat: Infinity, ease: "easeInOut", delay: 1.1 }}
                />
                <motion.line
                  x1="65" y1="65" x2="50" y2="90"
                  stroke="#ef4444" strokeWidth="0.03" opacity="0.04"
                  animate={{ opacity: [0.001, 0.04, 0.001] }}
                  transition={{ duration: 9.3, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
                />
                
                {/* Extreme micro density - Additional cross lines */}
                <motion.line
                  x1="20" y1="20" x2="65" y2="35"
                  stroke="#8b5cf6" strokeWidth="0.02" opacity="0.03"
                  animate={{ opacity: [0.0005, 0.03, 0.0005] }}
                  transition={{ duration: 10.2, repeat: Infinity, ease: "easeInOut", delay: 0.7 }}
                />
                <motion.line
                  x1="80" y1="20" x2="35" y2="35"
                  stroke="#06b6d4" strokeWidth="0.02" opacity="0.03"
                  animate={{ opacity: [0.0005, 0.03, 0.0005] }}
                  transition={{ duration: 10.5, repeat: Infinity, ease: "easeInOut", delay: 1.4 }}
                />
                <motion.line
                  x1="20" y1="80" x2="65" y2="65"
                  stroke="#a855f7" strokeWidth="0.02" opacity="0.03"
                  animate={{ opacity: [0.0005, 0.03, 0.0005] }}
                  transition={{ duration: 10.8, repeat: Infinity, ease: "easeInOut", delay: 0.9 }}
                />
                <motion.line
                  x1="80" y1="80" x2="35" y2="65"
                  stroke="#22c55e" strokeWidth="0.02" opacity="0.03"
                  animate={{ opacity: [0.0005, 0.03, 0.0005] }}
                  transition={{ duration: 10.1, repeat: Infinity, ease: "easeInOut", delay: 1.6 }}
                />
                
                {/* Maximum extreme density - Ultra micro connections */}
                <motion.line
                  x1="20" y1="20" x2="35" y2="65"
                  stroke="#3b82f6" strokeWidth="0.015" opacity="0.025"
                  animate={{ opacity: [0.0002, 0.02, 0.0002] }}
                  transition={{ duration: 11.5, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
                />
                <motion.line
                  x1="80" y1="20" x2="65" y2="65"
                  stroke="#10b981" strokeWidth="0.015" opacity="0.025"
                  animate={{ opacity: [0.0002, 0.02, 0.0002] }}
                  transition={{ duration: 11.8, repeat: Infinity, ease: "easeInOut", delay: 1.1 }}
                />
                <motion.line
                  x1="20" y1="80" x2="35" y2="35"
                  stroke="#f59e0b" strokeWidth="0.015" opacity="0.025"
                  animate={{ opacity: [0.0002, 0.02, 0.0002] }}
                  transition={{ duration: 12.1, repeat: Infinity, ease: "easeInOut", delay: 1.7 }}
                />
                <motion.line
                  x1="80" y1="80" x2="65" y2="35"
                  stroke="#ef4444" strokeWidth="0.015" opacity="0.025"
                  animate={{ opacity: [0.0002, 0.02, 0.0002] }}
                  transition={{ duration: 11.2, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                />
                
                {/* Ultra maximum density - Cross micro connections */}
                <motion.line
                  x1="10" y1="50" x2="35" y2="35"
                  stroke="#8b5cf6" strokeWidth="0.015" opacity="0.025"
                  animate={{ opacity: [0.0002, 0.02, 0.0002] }}
                  transition={{ duration: 12.5, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                />
                <motion.line
                  x1="90" y1="50" x2="65" y2="35"
                  stroke="#06b6d4" strokeWidth="0.015" opacity="0.025"
                  animate={{ opacity: [0.0002, 0.02, 0.0002] }}
                  transition={{ duration: 12.8, repeat: Infinity, ease: "easeInOut", delay: 1.5 }}
                />
                <motion.line
                  x1="50" y1="10" x2="35" y2="65"
                  stroke="#a855f7" strokeWidth="0.015" opacity="0.025"
                  animate={{ opacity: [0.0002, 0.02, 0.0002] }}
                  transition={{ duration: 13.1, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
                />
                <motion.line
                  x1="50" y1="90" x2="65" y2="35"
                  stroke="#22c55e" strokeWidth="0.015" opacity="0.025"
                  animate={{ opacity: [0.0002, 0.02, 0.0002] }}
                  transition={{ duration: 12.3, repeat: Infinity, ease: "easeInOut", delay: 1.9 }}
                />
                
                {/* Extreme ultra density - Additional micro cross lines */}
                <motion.line
                  x1="20" y1="20" x2="50" y2="50"
                  stroke="#3b82f6" strokeWidth="0.01" opacity="0.02"
                  animate={{ opacity: [0.0001, 0.015, 0.0001] }}
                  transition={{ duration: 13.8, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
                />
                <motion.line
                  x1="80" y1="20" x2="50" y2="50"
                  stroke="#10b981" strokeWidth="0.01" opacity="0.02"
                  animate={{ opacity: [0.0001, 0.015, 0.0001] }}
                  transition={{ duration: 14.1, repeat: Infinity, ease: "easeInOut", delay: 1.3 }}
                />
                <motion.line
                  x1="20" y1="80" x2="50" y2="50"
                  stroke="#f59e0b" strokeWidth="0.01" opacity="0.02"
                  animate={{ opacity: [0.0001, 0.015, 0.0001] }}
                  transition={{ duration: 14.4, repeat: Infinity, ease: "easeInOut", delay: 0.7 }}
                />
                <motion.line
                  x1="80" y1="80" x2="50" y2="50"
                  stroke="#ef4444" strokeWidth="0.01" opacity="0.02"
                  animate={{ opacity: [0.0001, 0.015, 0.0001] }}
                  transition={{ duration: 13.5, repeat: Infinity, ease: "easeInOut", delay: 1.8 }}
                />
                
                {/* Maximum ultra density - Inner micro connections */}
                <motion.line
                  x1="35" y1="35" x2="20" y2="20"
                  stroke="#8b5cf6" strokeWidth="0.01" opacity="0.02"
                  animate={{ opacity: [0.0001, 0.015, 0.0001] }}
                  transition={{ duration: 15.2, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                />
                <motion.line
                  x1="65" y1="35" x2="80" y2="20"
                  stroke="#06b6d4" strokeWidth="0.01" opacity="0.02"
                  animate={{ opacity: [0.0001, 0.015, 0.0001] }}
                  transition={{ duration: 15.5, repeat: Infinity, ease: "easeInOut", delay: 1.2 }}
                />
                <motion.line
                  x1="35" y1="65" x2="20" y2="80"
                  stroke="#a855f7" strokeWidth="0.01" opacity="0.02"
                  animate={{ opacity: [0.0001, 0.015, 0.0001] }}
                  transition={{ duration: 15.8, repeat: Infinity, ease: "easeInOut", delay: 0.9 }}
                />
                <motion.line
                  x1="65" y1="65" x2="80" y2="80"
                  stroke="#22c55e" strokeWidth="0.01" opacity="0.02"
                  animate={{ opacity: [0.0001, 0.015, 0.0001] }}
                  transition={{ duration: 14.9, repeat: Infinity, ease: "easeInOut", delay: 1.6 }}
                />
                
                {/* Ultra extreme density - Cross micro connections */}
                <motion.line
                  x1="10" y1="50" x2="65" y2="35"
                  stroke="#3b82f6" strokeWidth="0.008" opacity="0.015"
                  animate={{ opacity: [0.00005, 0.01, 0.00005] }}
                  transition={{ duration: 16.5, repeat: Infinity, ease: "easeInOut", delay: 0.1 }}
                />
                <motion.line
                  x1="90" y1="50" x2="35" y2="35"
                  stroke="#10b981" strokeWidth="0.008" opacity="0.015"
                  animate={{ opacity: [0.00005, 0.01, 0.00005] }}
                  transition={{ duration: 16.8, repeat: Infinity, ease: "easeInOut", delay: 1.4 }}
                />
                <motion.line
                  x1="50" y1="10" x2="35" y2="65"
                  stroke="#f59e0b" strokeWidth="0.008" opacity="0.015"
                  animate={{ opacity: [0.00005, 0.01, 0.00005] }}
                  transition={{ duration: 17.1, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                />
                <motion.line
                  x1="50" y1="90" x2="65" y2="35"
                  stroke="#ef4444" strokeWidth="0.008" opacity="0.015"
                  animate={{ opacity: [0.00005, 0.01, 0.00005] }}
                  transition={{ duration: 16.2, repeat: Infinity, ease: "easeInOut", delay: 1.7 }}
                />
                
                {/* Maximum dramatic density - Ultra micro connections */}
                <motion.line
                  x1="20" y1="20" x2="10" y2="50"
                  stroke="#8b5cf6" strokeWidth="0.006" opacity="0.012"
                  animate={{ opacity: [0.00002, 0.008, 0.00002] }}
                  transition={{ duration: 18.5, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
                />
                <motion.line
                  x1="80" y1="20" x2="90" y2="50"
                  stroke="#06b6d4" strokeWidth="0.006" opacity="0.012"
                  animate={{ opacity: [0.00002, 0.008, 0.00002] }}
                  transition={{ duration: 18.8, repeat: Infinity, ease: "easeInOut", delay: 1.1 }}
                />
                <motion.line
                  x1="20" y1="80" x2="10" y2="50"
                  stroke="#a855f7" strokeWidth="0.006" opacity="0.012"
                  animate={{ opacity: [0.00002, 0.008, 0.00002] }}
                  transition={{ duration: 19.1, repeat: Infinity, ease: "easeInOut", delay: 1.6 }}
                />
                <motion.line
                  x1="80" y1="80" x2="90" y2="50"
                  stroke="#22c55e" strokeWidth="0.006" opacity="0.012"
                  animate={{ opacity: [0.00002, 0.008, 0.00002] }}
                  transition={{ duration: 18.2, repeat: Infinity, ease: "easeInOut", delay: 0.7 }}
                />
                
                {/* Ultra dramatic density - Cross micro connections */}
                <motion.line
                  x1="20" y1="20" x2="50" y2="10"
                  stroke="#3b82f6" strokeWidth="0.006" opacity="0.012"
                  animate={{ opacity: [0.00002, 0.008, 0.00002] }}
                  transition={{ duration: 19.5, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                />
                <motion.line
                  x1="80" y1="20" x2="50" y2="10"
                  stroke="#10b981" strokeWidth="0.006" opacity="0.012"
                  animate={{ opacity: [0.00002, 0.008, 0.00002] }}
                  transition={{ duration: 19.8, repeat: Infinity, ease: "easeInOut", delay: 1.3 }}
                />
                <motion.line
                  x1="20" y1="80" x2="50" y2="90"
                  stroke="#f59e0b" strokeWidth="0.006" opacity="0.012"
                  animate={{ opacity: [0.00002, 0.008, 0.00002] }}
                  transition={{ duration: 20.1, repeat: Infinity, ease: "easeInOut", delay: 0.9 }}
                />
                <motion.line
                  x1="80" y1="80" x2="50" y2="90"
                  stroke="#ef4444" strokeWidth="0.006" opacity="0.012"
                  animate={{ opacity: [0.00002, 0.008, 0.00002] }}
                  transition={{ duration: 19.2, repeat: Infinity, ease: "easeInOut", delay: 1.8 }}
                />
                
                {/* Extreme dramatic density - Inner micro connections */}
                <motion.line
                  x1="35" y1="35" x2="10" y2="50"
                  stroke="#8b5cf6" strokeWidth="0.005" opacity="0.01"
                  animate={{ opacity: [0.00001, 0.006, 0.00001] }}
                  transition={{ duration: 21.5, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
                />
                <motion.line
                  x1="65" y1="35" x2="90" y2="50"
                  stroke="#06b6d4" strokeWidth="0.005" opacity="0.01"
                  animate={{ opacity: [0.00001, 0.006, 0.00001] }}
                  transition={{ duration: 21.8, repeat: Infinity, ease: "easeInOut", delay: 1.5 }}
                />
                <motion.line
                  x1="35" y1="65" x2="10" y2="50"
                  stroke="#a855f7" strokeWidth="0.005" opacity="0.01"
                  animate={{ opacity: [0.00001, 0.006, 0.00001] }}
                  transition={{ duration: 22.1, repeat: Infinity, ease: "easeInOut", delay: 1.1 }}
                />
                <motion.line
                  x1="65" y1="65" x2="90" y2="50"
                  stroke="#22c55e" strokeWidth="0.005" opacity="0.01"
                  animate={{ opacity: [0.00001, 0.006, 0.00001] }}
                  transition={{ duration: 20.8, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                />
                
                {/* Maximum dramatic density - Ultra micro connections */}
                <motion.line
                  x1="35" y1="35" x2="50" y2="10"
                  stroke="#3b82f6" strokeWidth="0.005" opacity="0.01"
                  animate={{ opacity: [0.00001, 0.006, 0.00001] }}
                  transition={{ duration: 22.5, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
                />
                <motion.line
                  x1="65" y1="35" x2="50" y2="10"
                  stroke="#10b981" strokeWidth="0.005" opacity="0.01"
                  animate={{ opacity: [0.00001, 0.006, 0.00001] }}
                  transition={{ duration: 22.8, repeat: Infinity, ease: "easeInOut", delay: 1.7 }}
                />
                <motion.line
                  x1="35" y1="65" x2="50" y2="90"
                  stroke="#f59e0b" strokeWidth="0.005" opacity="0.01"
                  animate={{ opacity: [0.00001, 0.006, 0.00001] }}
                  transition={{ duration: 23.1, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                />
                <motion.line
                  x1="65" y1="65" x2="50" y2="90"
                  stroke="#ef4444" strokeWidth="0.005" opacity="0.01"
                  animate={{ opacity: [0.00001, 0.006, 0.00001] }}
                  transition={{ duration: 21.2, repeat: Infinity, ease: "easeInOut", delay: 1.4 }}
                />
                
                {/* Ultra maximum dramatic density - Cross micro connections */}
                <motion.line
                  x1="20" y1="20" x2="65" y2="35"
                  stroke="#8b5cf6" strokeWidth="0.004" opacity="0.008"
                  animate={{ opacity: [0.000005, 0.004, 0.000005] }}
                  transition={{ duration: 24.5, repeat: Infinity, ease: "easeInOut", delay: 0.1 }}
                />
                <motion.line
                  x1="80" y1="20" x2="35" y2="35"
                  stroke="#06b6d4" strokeWidth="0.004" opacity="0.008"
                  animate={{ opacity: [0.000005, 0.004, 0.000005] }}
                  transition={{ duration: 24.8, repeat: Infinity, ease: "easeInOut", delay: 1.2 }}
                />
                <motion.line
                  x1="20" y1="80" x2="65" y2="65"
                  stroke="#a855f7" strokeWidth="0.004" opacity="0.008"
                  animate={{ opacity: [0.000005, 0.004, 0.000005] }}
                  transition={{ duration: 25.1, repeat: Infinity, ease: "easeInOut", delay: 0.7 }}
                />
                <motion.line
                  x1="80" y1="80" x2="35" y2="65"
                  stroke="#22c55e" strokeWidth="0.004" opacity="0.008"
                  animate={{ opacity: [0.000005, 0.004, 0.000005] }}
                  transition={{ duration: 23.8, repeat: Infinity, ease: "easeInOut", delay: 1.9 }}
                />
                
                {/* Extreme ultra dramatic density - Additional micro connections */}
                <motion.line
                  x1="10" y1="50" x2="35" y2="35"
                  stroke="#3b82f6" strokeWidth="0.004" opacity="0.008"
                  animate={{ opacity: [0.000005, 0.004, 0.000005] }}
                  transition={{ duration: 25.5, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
                />
                <motion.line
                  x1="90" y1="50" x2="65" y2="35"
                  stroke="#10b981" strokeWidth="0.004" opacity="0.008"
                  animate={{ opacity: [0.000005, 0.004, 0.000005] }}
                  transition={{ duration: 25.8, repeat: Infinity, ease: "easeInOut", delay: 1.6 }}
                />
                <motion.line
                  x1="50" y1="10" x2="35" y2="65"
                  stroke="#f59e0b" strokeWidth="0.004" opacity="0.008"
                  animate={{ opacity: [0.000005, 0.004, 0.000005] }}
                  transition={{ duration: 26.1, repeat: Infinity, ease: "easeInOut", delay: 0.9 }}
                />
                <motion.line
                  x1="50" y1="90" x2="65" y2="35"
                  stroke="#ef4444" strokeWidth="0.004" opacity="0.008"
                  animate={{ opacity: [0.000005, 0.004, 0.000005] }}
                  transition={{ duration: 24.2, repeat: Infinity, ease: "easeInOut", delay: 1.3 }}
                />
                
                {/* 3D Perspective Lines - Front Layer */}
                <motion.line
                  x1="15" y1="15" x2="85" y2="15"
                  stroke="#3b82f6" strokeWidth="0.3" opacity="0.2"
                  animate={{ opacity: [0.05, 0.3, 0.05] }}
                  transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut", delay: 0.1 }}
                />
                <motion.line
                  x1="15" y1="85" x2="85" y2="85"
                  stroke="#10b981" strokeWidth="0.3" opacity="0.2"
                  animate={{ opacity: [0.05, 0.3, 0.05] }}
                  transition={{ duration: 2.8, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                />
                <motion.line
                  x1="15" y1="15" x2="15" y2="85"
                  stroke="#f59e0b" strokeWidth="0.3" opacity="0.2"
                  animate={{ opacity: [0.05, 0.3, 0.05] }}
                  transition={{ duration: 2.3, repeat: Infinity, ease: "easeInOut", delay: 1.1 }}
                />
                <motion.line
                  x1="85" y1="15" x2="85" y2="85"
                  stroke="#ef4444" strokeWidth="0.3" opacity="0.2"
                  animate={{ opacity: [0.05, 0.3, 0.05] }}
                  transition={{ duration: 2.7, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
                />
                
                {/* 3D Perspective Lines - Middle Layer */}
                <motion.line
                  x1="25" y1="25" x2="75" y2="25"
                  stroke="#8b5cf6" strokeWidth="0.2" opacity="0.15"
                  animate={{ opacity: [0.03, 0.2, 0.03] }}
                  transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
                />
                <motion.line
                  x1="25" y1="75" x2="75" y2="75"
                  stroke="#06b6d4" strokeWidth="0.2" opacity="0.15"
                  animate={{ opacity: [0.03, 0.2, 0.03] }}
                  transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                />
                <motion.line
                  x1="25" y1="25" x2="25" y2="75"
                  stroke="#a855f7" strokeWidth="0.2" opacity="0.15"
                  animate={{ opacity: [0.03, 0.2, 0.03] }}
                  transition={{ duration: 3.0, repeat: Infinity, ease: "easeInOut", delay: 1.3 }}
                />
                <motion.line
                  x1="75" y1="25" x2="75" y2="75"
                  stroke="#22c55e" strokeWidth="0.2" opacity="0.15"
                  animate={{ opacity: [0.03, 0.2, 0.03] }}
                  transition={{ duration: 3.3, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                />
                
                {/* 3D Perspective Lines - Back Layer */}
                <motion.line
                  x1="5" y1="5" x2="95" y2="5"
                  stroke="#3b82f6" strokeWidth="0.1" opacity="0.08"
                  animate={{ opacity: [0.01, 0.12, 0.01] }}
                  transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut", delay: 0.3 }}
                />
                <motion.line
                  x1="5" y1="95" x2="95" y2="95"
                  stroke="#10b981" strokeWidth="0.1" opacity="0.08"
                  animate={{ opacity: [0.01, 0.12, 0.01] }}
                  transition={{ duration: 4.8, repeat: Infinity, ease: "easeInOut", delay: 1.0 }}
                />
                <motion.line
                  x1="5" y1="5" x2="5" y2="95"
                  stroke="#f59e0b" strokeWidth="0.1" opacity="0.08"
                  animate={{ opacity: [0.01, 0.12, 0.01] }}
                  transition={{ duration: 4.2, repeat: Infinity, ease: "easeInOut", delay: 1.5 }}
                />
                <motion.line
                  x1="95" y1="5" x2="95" y2="95"
                  stroke="#ef4444" strokeWidth="0.1" opacity="0.08"
                  animate={{ opacity: [0.01, 0.12, 0.01] }}
                  transition={{ duration: 4.6, repeat: Infinity, ease: "easeInOut", delay: 0.7 }}
                />
                
                {/* 3D Depth Lines - Diagonal Perspective */}
                <motion.line
                  x1="10" y1="10" x2="20" y2="20"
                  stroke="#8b5cf6" strokeWidth="0.15" opacity="0.1"
                  animate={{ opacity: [0.02, 0.15, 0.02] }}
                  transition={{ duration: 3.8, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
                />
                <motion.line
                  x1="90" y1="10" x2="80" y2="20"
                  stroke="#06b6d4" strokeWidth="0.15" opacity="0.1"
                  animate={{ opacity: [0.02, 0.15, 0.02] }}
                  transition={{ duration: 4.1, repeat: Infinity, ease: "easeInOut", delay: 1.2 }}
                />
                <motion.line
                  x1="10" y1="90" x2="20" y2="80"
                  stroke="#a855f7" strokeWidth="0.15" opacity="0.1"
                  animate={{ opacity: [0.02, 0.15, 0.02] }}
                  transition={{ duration: 3.9, repeat: Infinity, ease: "easeInOut", delay: 0.9 }}
                />
                <motion.line
                  x1="90" y1="90" x2="80" y2="80"
                  stroke="#22c55e" strokeWidth="0.15" opacity="0.1"
                  animate={{ opacity: [0.02, 0.15, 0.02] }}
                  transition={{ duration: 4.3, repeat: Infinity, ease: "easeInOut", delay: 1.6 }}
                />
                
                {/* 3D Depth Lines - Cross Perspective */}
                <motion.line
                  x1="5" y1="50" x2="15" y2="50"
                  stroke="#3b82f6" strokeWidth="0.12" opacity="0.09"
                  animate={{ opacity: [0.015, 0.12, 0.015] }}
                  transition={{ duration: 4.7, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
                />
                <motion.line
                  x1="95" y1="50" x2="85" y2="50"
                  stroke="#10b981" strokeWidth="0.12" opacity="0.09"
                  animate={{ opacity: [0.015, 0.12, 0.015] }}
                  transition={{ duration: 5.0, repeat: Infinity, ease: "easeInOut", delay: 1.4 }}
                />
                <motion.line
                  x1="50" y1="5" x2="50" y2="15"
                  stroke="#f59e0b" strokeWidth="0.12" opacity="0.09"
                  animate={{ opacity: [0.015, 0.12, 0.015] }}
                  transition={{ duration: 4.4, repeat: Infinity, ease: "easeInOut", delay: 1.1 }}
                />
                <motion.line
                  x1="50" y1="95" x2="50" y2="85"
                  stroke="#ef4444" strokeWidth="0.12" opacity="0.09"
                  animate={{ opacity: [0.015, 0.12, 0.015] }}
                  transition={{ duration: 4.9, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
                />
                
                {/* 3D Depth Lines - Inner Perspective */}
                <motion.line
                  x1="30" y1="30" x2="40" y2="40"
                  stroke="#8b5cf6" strokeWidth="0.08" opacity="0.06"
                  animate={{ opacity: [0.01, 0.08, 0.01] }}
                  transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
                />
                <motion.line
                  x1="70" y1="30" x2="60" y2="40"
                  stroke="#06b6d4" strokeWidth="0.08" opacity="0.06"
                  animate={{ opacity: [0.01, 0.08, 0.01] }}
                  transition={{ duration: 5.8, repeat: Infinity, ease: "easeInOut", delay: 1.0 }}
                />
                <motion.line
                  x1="30" y1="70" x2="40" y2="60"
                  stroke="#a855f7" strokeWidth="0.08" opacity="0.06"
                  animate={{ opacity: [0.01, 0.08, 0.01] }}
                  transition={{ duration: 5.3, repeat: Infinity, ease: "easeInOut", delay: 1.7 }}
                />
                <motion.line
                  x1="70" y1="70" x2="60" y2="60"
                  stroke="#22c55e" strokeWidth="0.08" opacity="0.06"
                  animate={{ opacity: [0.01, 0.08, 0.01] }}
                  transition={{ duration: 5.6, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
                />
                
                {/* Central Core */}
                <motion.circle
                  cx="50"
                  cy="50"
                  r="15"
                  fill="url(#gradient4)"
                  animate={{ 
                    scale: [1, 1.1, 1],
                    opacity: [0.8, 1, 0.8]
                  }}
                  transition={{ 
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                />
                
                {/* Floating Tech Elements */}
                <motion.circle
                  cx="50"
                  cy="20"
                  r="2"
                  fill="#3b82f6"
                  animate={{ 
                    y: [20, 15, 20],
                    opacity: [0.6, 1, 0.6]
                  }}
                  transition={{ 
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                />
                <motion.circle
                  cx="80"
                  cy="50"
                  r="1.5"
                  fill="#10b981"
                  animate={{ 
                    x: [80, 75, 80],
                    opacity: [0.4, 0.9, 0.4]
                  }}
                  transition={{ 
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.3
                  }}
                />
                <motion.circle
                  cx="50"
                  cy="80"
                  r="1.5"
                  fill="#f59e0b"
                  animate={{ 
                    y: [80, 85, 80],
                    opacity: [0.5, 1, 0.5]
                  }}
                  transition={{ 
                    duration: 1.8,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.6
                  }}
                />
                <motion.circle
                  cx="20"
                  cy="50"
                  r="1"
                  fill="#ef4444"
                  animate={{ 
                    x: [20, 25, 20],
                    opacity: [0.3, 0.8, 0.3]
                  }}
                  transition={{ 
                    duration: 2.2,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.9
                  }}
                />
                
                {/* Particle Effects */}
                {/* Outer Particles */}
                <motion.circle
                  cx="10"
                  cy="10"
                  r="1"
                  fill="#3b82f6"
                  animate={{ 
                    scale: [0.5, 1.5, 0.5],
                    opacity: [0.3, 1, 0.3]
                  }}
                  transition={{ 
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                />
                <motion.circle
                  cx="90"
                  cy="15"
                  r="0.8"
                  fill="#10b981"
                  animate={{ 
                    scale: [0.3, 1.2, 0.3],
                    opacity: [0.2, 0.9, 0.2]
                  }}
                  transition={{ 
                    duration: 2.5,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.5
                  }}
                />
                <motion.circle
                  cx="85"
                  cy="85"
                  r="1.2"
                  fill="#f59e0b"
                  animate={{ 
                    scale: [0.4, 1.8, 0.4],
                    opacity: [0.4, 1, 0.4]
                  }}
                  transition={{ 
                    duration: 1.8,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 1
                  }}
                />
                <motion.circle
                  cx="15"
                  cy="90"
                  r="0.6"
                  fill="#ef4444"
                  animate={{ 
                    scale: [0.2, 1.3, 0.2],
                    opacity: [0.3, 0.8, 0.3]
                  }}
                  transition={{ 
                    duration: 2.2,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 1.5
                  }}
                />
                
                {/* Middle Ring Particles */}
                <motion.circle
                  cx="25"
                  cy="25"
                  r="0.5"
                  fill="#8b5cf6"
                  animate={{ 
                    scale: [0.3, 1, 0.3],
                    opacity: [0.2, 0.7, 0.2]
                  }}
                  transition={{ 
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.3
                  }}
                />
                <motion.circle
                  cx="75"
                  cy="25"
                  r="0.7"
                  fill="#06b6d4"
                  animate={{ 
                    scale: [0.4, 1.1, 0.4],
                    opacity: [0.3, 0.8, 0.3]
                  }}
                  transition={{ 
                    duration: 1.7,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.8
                  }}
                />
                <motion.circle
                  cx="75"
                  cy="75"
                  r="0.4"
                  fill="#a855f7"
                  animate={{ 
                    scale: [0.2, 0.9, 0.2],
                    opacity: [0.2, 0.6, 0.2]
                  }}
                  transition={{ 
                    duration: 1.9,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 1.2
                  }}
                />
                <motion.circle
                  cx="25"
                  cy="75"
                  r="0.6"
                  fill="#3b82f6"
                  animate={{ 
                    scale: [0.3, 1, 0.3],
                    opacity: [0.3, 0.7, 0.3]
                  }}
                  transition={{ 
                    duration: 1.6,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.6
                  }}
                />
                
                {/* Inner Ring Particles */}
                <motion.circle
                  cx="35"
                  cy="35"
                  r="0.3"
                  fill="#10b981"
                  animate={{ 
                    scale: [0.2, 0.8, 0.2],
                    opacity: [0.1, 0.5, 0.1]
                  }}
                  transition={{ 
                    duration: 1.3,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.4
                  }}
                />
                <motion.circle
                  cx="65"
                  cy="35"
                  r="0.4"
                  fill="#f59e0b"
                  animate={{ 
                    scale: [0.1, 0.7, 0.1],
                    opacity: [0.2, 0.6, 0.2]
                  }}
                  transition={{ 
                    duration: 1.4,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.9
                  }}
                />
                <motion.circle
                  cx="65"
                  cy="65"
                  r="0.2"
                  fill="#ef4444"
                  animate={{ 
                    scale: [0.1, 0.6, 0.1],
                    opacity: [0.1, 0.4, 0.1]
                  }}
                  transition={{ 
                    duration: 1.1,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 1.3
                  }}
                />
                <motion.circle
                  cx="35"
                  cy="65"
                  r="0.3"
                  fill="#8b5cf6"
                  animate={{ 
                    scale: [0.2, 0.8, 0.2],
                    opacity: [0.2, 0.5, 0.2]
                  }}
                  transition={{ 
                    duration: 1.2,
                    repeat: Infinity,
                    ease: "easeInOut",
                    delay: 0.7
                  }}
                />
                
                {/* Gradient Definitions */}
                <defs>
                  <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#3b82f6" />
                    <stop offset="50%" stopColor="#8b5cf6" />
                    <stop offset="100%" stopColor="#06b6d4" />
                  </linearGradient>
                  <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#10b981" />
                    <stop offset="50%" stopColor="#3b82f6" />
                    <stop offset="100%" stopColor="#8b5cf6" />
                  </linearGradient>
                  <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#f59e0b" />
                    <stop offset="50%" stopColor="#ef4444" />
                    <stop offset="100%" stopColor="#8b5cf6" />
                  </linearGradient>
                  <radialGradient id="gradient4" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="#ffffff" stopOpacity="0.9" />
                    <stop offset="70%" stopColor="#3b82f6" stopOpacity="0.7" />
                    <stop offset="100%" stopColor="#1e40af" stopOpacity="0.5" />
                  </radialGradient>
                </defs>
              </svg>
            </motion.div>
          </motion.div>

          {/* Main Title - Much smaller and more compact */}
          <h1 className="text-xl lg:text-2xl text-white leading-tight mb-4 font-slim font-light tracking-wide">
            <div className="inline-block">
              <SplitTextTest
                text="Where AI works, you win!"
                className=""
                delay={0.1}
                duration={0.6}
                ease="power3.out"
                from={{ opacity: 0, y: 40 }}
                to={{ opacity: 1, y: 0 }}
                onComplete={handleAnimationComplete}
              />
              {showCursor && (
                <motion.span
                  className="inline-block text-white ml-1"
                  animate={{ 
                    opacity: [1, 0, 1],
                  }}
                  transition={{ 
                    duration: 1,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                >
                  _
                </motion.span>
              )}
            </div>
          </h1>

        </div>
      </div>

      {/* Animated Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.2 }}
        className="absolute bottom-3 left-1/2 transform -translate-x-1/2 z-10"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="flex flex-col items-center cursor-pointer"
        >
          <span className="text-gray-400 text-sm mb-2 font-slim">Scroll</span>
          <div className="w-6 h-10 border-2 border-gray-400 rounded-full flex justify-center">
            <motion.div
              animate={{ y: [0, 12, 0] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
              className="w-1.5 h-3 bg-gradient-to-b from-blue-400 to-purple-400 rounded-full mt-2"
            />
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
